import { createContext, useState } from 'react';

// Holds the admin-selected unit so LoggedInContext can attach it to every request.
// Workforce users never set this — the backend derives their unit from identity.
export const UnitSelectionContext = createContext({});

export const UnitSelectionProvider = ({ children }) => {
    const [selectedUnit, setSelectedUnit] = useState(null);

    return (
        <UnitSelectionContext.Provider
            value={{ selectedUnit, setSelectedUnit }}
        >
            {children}
        </UnitSelectionContext.Provider>
    );
};
